import { useCompany } from "../CompanyProvider/CompanyProvider";
import { selectDynamicPostalCodeMask } from "./PostalCodeTextMask-utils";
export const DEFAULT_MASK = [{ mask: "00000" }];
// This will need to be updated when a company is in a new region
export var RequiresMultipleTextMasks;
(function (RequiresMultipleTextMasks) {
    RequiresMultipleTextMasks["UNITED_KINGDOM"] = "en-GB";
})(RequiresMultipleTextMasks || (RequiresMultipleTextMasks = {}));
/**
 * Custom hook for applying text masks to postal code inputs.
 * This hook utilizes the `useCompany` hook to retrieve culture and postal code mask settings.
 * It determines whether a dispatch function is required for the postal code masking logic,
 * particularly for the United Kingdom where multiple text masks might be necessary based on the input.
 *
 * @returns {Object} An object containing:
 * - `masks`: An array of mask definitions
 * - `shouldUseDispatch`: A boolean indicating whether the dispatch function needs to be used,
 *    specifically true for the United Kingdom due to its requirement for multiple text masks.
 * - `dispatch`: A function that applies the correct postal code mask based on the input.
 */
export const usePostalCodeTextMask = () => {
    const { culture: { cultureInfo }, postalCodeMasks, } = useCompany();
    // United Kingdom is the only country (so far) that requires the dispatch function so
    // it can apply the correct mask
    const shouldUseDispatch = cultureInfo === RequiresMultipleTextMasks.UNITED_KINGDOM;
    return {
        masks: postalCodeMasks,
        shouldUseDispatch,
        dispatch: selectDynamicPostalCodeMask(postalCodeMasks),
    };
};
